import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {DatePipe, JsonPipe, NgForOf, NgIf} from "@angular/common";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { ClrDatepickerModule, ClrSelectModule, ClrTextareaModule } from "@clr/angular";
import { AlertService, IAlertType, PersonsStoreService } from "../../../_shared/services";
import { CommentsStoreService } from "../../../_shared/services/comments-store.service";
import { Personen } from "../../../_shared/interfaces";
import { TranslocoDirective } from "@jsverse/transloco";
import moment from "moment/moment";
import { getTenantStorage } from '../../../_shared/utils/tenant-context';

import { environment as env } from "../../../../environments/environment";

@Component({
  selector: 'app-comment-add',
  standalone: true,
  imports: [
    NgIf,
    ReactiveFormsModule,
    ClrTextareaModule,
    ClrSelectModule,
    NgForOf,
    ClrDatepickerModule,
    DatePipe,
    JsonPipe,
    TranslocoDirective
  ],
  templateUrl: './comment-add.component.html',
  styleUrl: './comment-add.component.sass'
})
export class CommentAddComponent implements OnInit {
  persons: Personen[] = [];
  public commentForm: FormGroup = new FormGroup({});
  devMode: boolean;
  private defaultDate: Date = new Date();

  @Input() commentType: number = 0;
  @Input() companyId: number = 0;
  @Input() projectId: string = '';
  @Input() subId: number = 0;
  @Input() staffId: number = 0;
  @Input() status: boolean = false;
  @Output() commentAdded = new EventEmitter<void>();


  constructor(
    private commentss: CommentsStoreService,
    private persss: PersonsStoreService,
    private alertDispatcher: AlertService,
    private fb: FormBuilder
  ) {
    this.devMode = env.stages.dev;
  }

  ngOnInit() {
    this.initCommentForm();
    this.loadCustomerList(this.companyId);
  }

  initCommentForm() {
    this.commentForm = this.fb.group({
      comment_type: this.commentType,
      done: false,
      entry: moment(this.defaultDate).format("DD.MM.yyyy"),
      id: 0,
      person_id: [0, Validators.min(1)],
      project: this.projectId,
      reason: "",
      remember: "",
      staff_id: parseInt(getTenantStorage('staff_id') ?? getTenantStorage('user_id') ?? '0', 10),
      sub_id: this.subId
    });
  }

  loadCustomerList(companyid: number) {
    this.persss.getPersonInCompany(companyid, true)
      .subscribe({
        next: data => {
          if (!data || !data.object || data.object.length === 0) {
            this.alertDispatcher.show({
              message: ' Keine Person gefunden! ',
              clrAlertType: IAlertType.WARNING
            }, 5000);
            return;
          }
          this.persons = data.object;
        },
        complete: () => {
          // Sortiere die Liste nach dem Nachnamen
          this.persons.sort((a, b) => {
            if (a.lastname < b.lastname) {
              return -1;
            }
            if (a.lastname > b.lastname) {
              return 1;
            }
            return 0;
          });

        },
        error: () => {
          return
        }
      });
  }

  addComment() {
    this.commentss.addComment(this.commentForm.value)
      .subscribe({
        next: () => {
          return true
        },
        complete: () => {
          this.alertDispatcher.show({
            message: ' Der Kommentar wurde hinzugefügt! ',
            clrAlertType: IAlertType.INFO
          }, 5000);
          // Reset the form
          this.initCommentForm();
          // Emit event to notify parent component
          this.commentAdded.emit();
        },
        error: () => {
          return false
        }
      });

  }
}
